module.exports = __webpack_public_path__ + "img/es.79b0098d.svg";